module.exports = __webpack_public_path__ + "static/media/empty-filters-result.84093c89.svg";